export default 'icon--mail';